<template>
    <div class="az-form-content credenciamento-documentos">
        <v-container fluid grid-list-xl style="padding-bottom: 80px">
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex class="pt-0" v-if="!isSolicitacaoCredenciamentoEnviada && licitacao.publicado">
                    <span class="az-subtitle primary--text">Enviar Documentos</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="!isSolicitacaoCredenciamentoEnviada && licitacao.publicado">
                    <edl-file-upload :accept="arquivosAceitos" :repository="repository" ref="azFileUploadCredenciamento" height="80px">
                        <a @click.prevent="$refs.azFileUploadCredenciamento.openFileSelector()">
                            <v-icon>archive</v-icon>
                            Importar Arquivos
                        </a>
                        <p>Arraste e solte os arquivos aqui para serem carregados.</p>
                    </edl-file-upload>
                </v-flex>
                <template v-if="!ehModoManual()">
                  <v-flex xs12 sm12 d-flex class="pb-0">
                    <span class="az-subtitle primary--text">Documentos de Credenciamento</span>
                  </v-flex>
                  <v-flex xs12 sm12 d-flex class="pt-0">
                    <v-data-table v-if="documentosCredenciamento.length > 0"
                                  :headers="computedHeaders" :items="documentosCredenciamento"
                                  :loading="false" hide-actions class="az-table-list tabela-documentos">
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td class="td-align">
                            <span>{{ verificarQualDataExibir(props.item) | az-date('DD/MM/YYYY HH:mm') }}</span>
                          </td>
                          <td class="td-align">
                              <v-tooltip top :disabled="props.item.descricao.length <= 50">
                                  <div slot="activator">
                                      <span v-if="props.item.descricao" style="overflow-wrap: anywhere">{{ props.item.descricao.toLowerCase().replace('.pdf','') | az-clip-text(50) }}</span>
                                      <span v-else>{{ 'Arquivo sem nome...' }}</span>
                                  </div>

                                  {{props.item.descricao}}
                              </v-tooltip>
                          </td>
                        <td align="left" style="text-align: left !important; padding: 0 !important;">
                            <situacao-pill-fornecedor :documento="props.item"/>
                        </td>
                            <td align="right" style="padding: 0; font-size: 10px" v-if="existeAlgumDocumentoAReenviar">
                                <div v-if="props.item.situacao === 'REENVIADO_TEMPORARIO' || props.item.situacao === 'ENVIADO_TEMPORARIO'"
                                     class="d-flex d-inline-flex grey--text"
                                     style="align-items: center;">

                                    Arquivo errado?
                                    <a @click.prevent="marcarArquivoComoAguardandoReenvio(props.item)"
                                       class="ml-1 primary--text text--lighten-2"
                                       style="text-decoration: underline;"> Anexar Outro</a>
                                </div>
                            </td>
                          <td class="table-actions">
                            <div class="d-inline-flex" style="align-items: center">
                                <credenciamento-unico-file-upload :key="props.item.id" v-show="aguardandoEnvioOuReenvio(props.item.situacao) && licitacao.publicado"
                                    :accept="arquivosAceitos"
                                    :repository="repository"
                                    ref="azFileUploadCredenciamento">
                                    <v-btn small color="primary" @click.prevent="processarReenvioArquivo(props.item)">
                                        <v-icon size="15">archive</v-icon>
                                        Anexar
                                    </v-btn>
                                </credenciamento-unico-file-upload>
                              <a v-if="props.item.situacao !== 'AGUARDANDO_ENVIO'" :href="criarLinkDownload(props.item.anexoUri)" target="_blank"
                                 class="az-action-link-icon">
                                <v-icon>get_app</v-icon>
                              </a>
                              <a @click.prevent="confirmarRemocao(props.item.id)" v-if="!isSolicitacaoCredenciamentoEnviada">
                                <v-icon>close</v-icon>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <az-ops v-if="!temDocumentosCredenciamento"
                            title=""
                            message="Não foram anexados documentos de Credenciamento."/>
                  </v-flex>
                </template>
            </v-layout>
        </v-container>
        <az-confirm @onConfirm="remover(); mostrarDialogRemoverArquivo = false;"
                    @onDecline="mostrarDialogRemoverArquivo = false"
                    v-if="mostrarDialogRemoverArquivo">
            Tem certeza que deseja remover o arquivo?
        </az-confirm>
        <az-confirm @onConfirm="sairDaTela(nextFunction); mostrarDialogConfirmarSaida = false;"
                    @onDecline="mostrarDialogConfirmarSaida = false"
                    v-if="mostrarDialogConfirmarSaida" :maxWidth=350>
            O upload de alguns arquivos ainda não terminou. Deseja sair da tela mesmo assim?
        </az-confirm>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import moment from 'moment'
import {actionTypes, mutationTypes} from '@/commons/constants'
import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";
import SituacaoPillFornecedor from "@/views/credenciamento/detalhe-credenciamento/commons/SituacaoPillFornecedor.vue";
import CredenciamentoUnicoFileUpload
    from "@/views/credenciamento/detalhe-credenciamento/fornecedor/botoes/CredenciamentoUnicoFileUpload.vue";

export default {
      name: 'CredenciamentoFornecedorDocumentos',
      components: {CredenciamentoUnicoFileUpload, SituacaoPillFornecedor, EdlFileUpload},
      data() {
            return {
                colunasTabela: [
                    {
                        text: 'Data',
                        align: 'left',
                        class: 'primary--text',
                        sortable: false,
                        width: '100px'
                    },
                    {
                        text: 'Nome',
                        class: 'primary--text',
                        sortable: false,
                        align: 'left',
                        width: '250px'
                    },
                    {
                        text: 'Situação',
                        class: 'primary--text',
                        sortable: false,
                        align: 'left',
                        width: '100px'
                    },
                    {
                        value: 'linkReanexar',
                        class: 'primary--text',
                        sortable: false,
                        align: 'center',
                        width: '100px',

                    },
                    {
                        text: 'Ações',
                        class: 'primary--text',
                        sortable: false,
                        align: 'center',
                        width: '100px',
                    }
                ],
                documentosHabilitacao: [],
                documentosCredenciamento: [],
                licitacaoId: null,
                mostrarDialogConfirmarSaida: false,
                mostrarDialogRemoverArquivo: false,
                nextFunction: null,
                solicitacaoDocumentoIdRemocao: null,
                exibirModalSelecionarTipoDocumento: false,
                anexoEmProcessoReenvio: null,
                pollingTimer: null
            }
        },
        computed: {
            isSolicitacaoCredenciamentoEnviada() {
                return this.propostaResumo.enviada
            },
            repository() {
                return `repo1:credenciamento/${this.licitacaoId}/solicitacao/fornecedor/${this.loki.user.domainId}/docsSolicitacao`
            },
            temDocumentosCredenciamento() {
                return this.documentosCredenciamento.length > 0
            },
            arquivosAceitos() {
                return this.parametros.propriedadesLicitacao.extensao
            },
            computedHeaders(){
                if(this.existeAlgumDocumentoAReenviar)
                    return this.colunasTabela
                return this.colunasTabela.filter(coluna => coluna.value !== "linkReanexar" )
            },
            existeAlgumDocumentoAReenviar(){
                return this.documentosCredenciamento.some(doc => doc.situacao === "REENVIADO_TEMPORARIO" || doc.situacao === "ENVIADO_TEMPORARIO")
            },
            ...mapState(['loki', 'propostaResumo','parametros', 'licitacao']),
            ehCredenciamentoAguardandoAbertura() {
                if (this.licitacao && this.licitacao.publicado) {
                    const dataAbertura = moment(this.licitacao.dataAbertura)
                    const dataAtual = moment(new Date())
                    return dataAtual.isBefore(dataAbertura)
                }
                return false
            }
        },
        beforeRouteLeave(to, from, next) {
            if (this.isUploadEmAndamento()) {
                this.confirmarSaidaDaTela(next)
            } else {
                this.sairDaTela(next)
            }
        },
        created() {
            this.desabilitarLoadingGlobal()
        },
        async mounted() {
            this.setLicitacaoId(this.$route.params.id)
            await this.buscarDocumentos()
            this.$root.$on('documentosReenviadosComSucesso', () => this.buscarDocumentos());
            if (this.ehCredenciamentoAguardandoAbertura) {
                this.iniciarPollingAbertura()
            }
        },
        beforeDestroy() {
            this.pararPollingAbertura()
        },
        watch: {
            ehCredenciamentoAguardandoAbertura(novo) {
                if (novo) {
                    this.iniciarPollingAbertura()
                } else {
                    this.pararPollingAbertura()
                }
            },
            'loki.uploadedFiles': {
              async handler() {
                if (this.isUploadArquivosTemporariosCompleto()) {
                  this.exibirModalSelecionarTipoDocumento = true
                  await this.inserir()
                }
              }
            }
        },
        methods: {
            async buscarDocumentos() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Carregando documentos de habilitação...')
                const todosDocumentos = await this.buscarDocumentosSolicitacaoCredenciamento(this.licitacaoId)
                this.documentosCredenciamento = todosDocumentos.anexos
                this.desabilitarLoadingGlobal()
                this.processarReenvioDocumentosNecessario()
            },
            confirmarRemocao(solicitacaoDocumentoId) {
                this.solicitacaoDocumentoIdRemocao = solicitacaoDocumentoId
                this.mostrarDialogRemoverArquivo = true
            },
            confirmarSaidaDaTela(next) {
                this.mostrarDialogConfirmarSaida = true
                this.nextFunction = next
            },
            criarDocumentos() {
                const documentos = []
                const uploadedFiles = this.loki.uploadedFiles
                for (let i = 0; i < uploadedFiles.length; i++) {
                    const file = uploadedFiles[i]
                    documentos.push({
                        descricao: file.name,
                        anexoUri: file.uri
                    })
                }
                return documentos
            },
            isUploadEmAndamento() {
                const arquivosEmProgresso = this.loki.uploadFileProgress
                const numeroArquivosEmProgresso = Object.keys(arquivosEmProgresso).length
                if (!numeroArquivosEmProgresso) {
                    return false
                }
                let isEmAndamento = false
                Object.keys(arquivosEmProgresso).forEach(chaveArquivo => {
                    const arquivo = arquivosEmProgresso[chaveArquivo]
                    if (!arquivo.error) {
                        isEmAndamento = true
                    }
                })
                return isEmAndamento
            },
            isUploadArquivosTemporariosCompleto() {
                return !this.isUploadEmAndamento() && this.loki.uploadedFiles.length > 0
            },
            async inserir() {
                this.exibirModalSelecionarTipoDocumento = false
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Salvando documentos...')
                try {
                    if(this.anexoEmProcessoReenvio !== null){
                        const anexosobmetido = this.loki.uploadedFiles[0]
                        const documentos = [
                            {
                                id: this.anexoEmProcessoReenvio.id,
                                solicitacaoCredenciamentoId: this.anexoEmProcessoReenvio.solicitacaoCredenciamentoId,
                                situacao: this.anexoEmProcessoReenvio.situacao,
                                descricao: anexosobmetido.name,
                                anexoUri: anexosobmetido.uri
                            }
                        ]

                        await this.inserirDocumentosSolicitacaoCredenciamento({
                            licitacaoId: this.licitacaoId,
                            documentos: {anexos: documentos}
                        })
                        this.anexoEmProcessoReenvio = null
                    }else {
                        this.mostrarDialogConfirmarSaida = false
                        const documentos = this.criarDocumentos()
                        await this.inserirDocumentosSolicitacaoCredenciamento({
                            licitacaoId: this.licitacaoId,
                            documentos: {anexos: documentos}
                        })
                    }

                    await this.buscarDocumentos()
                    await this.sincronizarProposta()
                    this.resetUploadedFiles()
                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoSucessoDefault()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async remover() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Removendo documento...')
                try {
                    await this.removerDocumentoSolicitacaoCredenciamento({
                        licitacaoId: this.licitacaoId,
                        documentoId: this.solicitacaoDocumentoIdRemocao
                    })
                    await this.buscarDocumentos()
                    await this.sincronizarProposta()
                    this.desabilitarLoadingGlobal()
                    this.solicitacaoDocumentoIdRemocao = false
                    this.mostrarNotificacaoSucessoDefault()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            sairDaTela(next) {
                this.habilitarLoadingGlobal()
                next()
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            ehModoManual(){
              return this.parametros.propriedadesLicitacao.modoCriacaoProcesso === 'MANUAL'
            },
            async sincronizarProposta() {
              this.setMensagemLoading('Sincronizando proposta...')
              await this.buscarPropostaResumo(this.licitacaoId)
            },
            ...mapActions({
              buscarPropostaResumo: actionTypes.BUSCAR_PROPOSTA_RESUMO,
              buscarDocumentosSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO,
              inserirDocumentosSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.INSERIR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO,
              removerDocumentoSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.REMOVER_DOCUMENTO_SOLICITACAO_CREDENCIAMENTO,
              buscarLicitacao: actionTypes.BUSCAR_LICITACAO
            }),
            processarReenvioArquivo(anexo){
                this.anexoEmProcessoReenvio = anexo
                this.$refs.azFileUploadCredenciamento.openFileSelector()
            },
            async marcarArquivoComoAguardandoReenvio(documento) {
                const dados = {
                    credenciamentoId: this.licitacaoId,
                    solicitacaoId: documento.solicitacaoCredenciamentoId,
                    documentoId: documento.id,
                    motivoReenvio: documento.motivoReenvio,
                    situacao: documento.situacao === 'REENVIADO_TEMPORARIO' ? 'AGUARDANDO_REENVIO' : 'AGUARDANDO_ENVIO'
                }

                const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.ALTERAR_SITUACAO_DOCUMENTO_CREDENCIAMENTO, dados)

                if (response.status === 200) {
                    documento.situacao = response.data.situacao
                    this.processarReenvioDocumentosNecessario()
                }else
                    throw new Error('Ocorreu um erro no processamento da requisição, por favor, tente novamente.')
            },
            processarReenvioDocumentosNecessario() {
                if(this.documentosCredenciamento.length > 0){
                    const primeiroAnexo = this.documentosCredenciamento[0]

                    const reenviarDocumentos ={
                            deveMostrarBotaoReenviarDocumentos: this.documentosCredenciamento.some(doc => doc.situacao === "REENVIADO_TEMPORARIO" || doc.situacao === "ENVIADO_TEMPORARIO"),
                            solicitacaoId: primeiroAnexo.solicitacaoCredenciamentoId
                        }
                    this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_REENVIAR_DOCUMENTOS_DADOS, reenviarDocumentos)
                }
            },
            verificarQualDataExibir(item) {
              if (this.aguardandoEnvioOuReenvio(item.situacao)) {
                return null
              }
              return item.dataAlteracao || item.dataCadastro
            },

            aguardandoEnvioOuReenvio(situacao) {
              return situacao === 'AGUARDANDO_REENVIO' || situacao === 'AGUARDANDO_ENVIO'
            },
            iniciarPollingAbertura() {
              if (this.pollingTimer) return
              this.pollingTimer = setInterval(async () => {
                if (!this.ehCredenciamentoAguardandoAbertura) {
                  await this.buscarLicitacao(this.$route.params.id)
                  clearInterval(this.pollingTimer)
                  this.pollingTimer = null
                }
              }, 5000)
            },
            pararPollingAbertura() {
              if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
                this.pollingTimer = null
              }
            }
        }
    }
</script>
<style lang="stylus">
  .td-align
    padding-left: 12px !important

  .credenciamento-documentos
    .az-drop-file a
      background-color #0067a5 !important
</style>
